import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon } from "../../icons";
const getDefaultAlignment = (langDir) => {
  return langDir === "rtl" ? "RIGHT" : "LEFT";
};
const alignmentMap = {
  LEFT: AlignLeftIcon,
  CENTER: AlignCenterIcon,
  RIGHT: AlignRightIcon
};
export {
  alignmentMap,
  getDefaultAlignment
};
//# sourceMappingURL=utils.js.map
